import React from 'react';
import { motion } from 'framer-motion';

const ProductCard = ({ 
  title, 
  subtitle = '', 
  description, 
  icon: Icon, 
  gradient = 'from-primary-500 to-secondary-500',
  delay = 0
}) => {
  return (
    <motion.div 
      className="glass-card overflow-hidden group h-full"
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, delay }}
      viewport={{ once: true, margin: "-50px" }}
      whileHover={{ 
        y: -8,
        transition: { duration: 0.3 }
      }}
    >
      <div className="p-6 md:p-8 h-full flex flex-col relative overflow-hidden">
        {/* Animated gradient background that appears on hover */}
        <motion.div 
          className={`absolute inset-0 bg-gradient-to-r ${gradient} opacity-0 group-hover:opacity-10 transition-opacity duration-500`}
          initial={{ x: '-100%' }}
          whileHover={{ x: 0 }}
          transition={{ duration: 0.6 }}
        />
        
        <motion.div 
          className={`bg-gradient-to-r ${gradient} p-4 rounded-xl w-16 h-16 flex items-center justify-center mb-6 relative z-10`}
          whileHover={{ 
            scale: 1.05,
            rotate: 5,
            transition: { duration: 0.3 }
          }}
        >
          <Icon className="text-white w-8 h-8" />
        </motion.div>
        
        <h3 className="text-xl md:text-2xl font-semibold text-white mb-1 relative z-10">
          {title}
        </h3>
        
        {subtitle && (
          <p className="text-primary-300 text-sm mb-3 relative z-10">
            {subtitle}
          </p>
        )}
        
        <p className="text-gray-300 mt-2 flex-grow relative z-10">
          {description}
        </p>
        
        <motion.div 
          className="mt-6 relative z-10"
          initial={{ x: 0 }}
          whileHover={{ x: 8 }}
          transition={{ duration: 0.3 }}
        >
          <a 
            href="#contact"
            className="inline-flex items-center text-accent-gold hover:text-white transition-colors"
          >
            Learn more
            <svg className="w-4 h-4 ml-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path 
                d="M5 12H19M19 12L12 5M19 12L12 19" 
                stroke="currentColor" 
                strokeWidth="2" 
                strokeLinecap="round" 
                strokeLinejoin="round"
              />
            </svg>
          </a>
        </motion.div>
      </div>
    </motion.div>
  );
};

export default ProductCard;